export default __webpack_public_path__ + "static/media/1798.5b16a87c.png";